import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-developmentdateexpected-history',
  templateUrl: './fes-workflow-action-developmentdateexpected-history.component.html',
  styleUrls: ['./fes-workflow-action-developmentdateexpected-history.component.scss']
})
export class FesWorkflowActionDevelopmentdateexpectedHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
